var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMt({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M503.172 88.276H256v335.448h247.172a8.829 8.829 0 0 0 8.828-8.828V97.103a8.828 8.828 0 0 0-8.828-8.827z",
    fill: "#ff4b55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.828 423.724H256V88.276H8.828A8.828 8.828 0 0 0 0 97.103v317.793a8.828 8.828 0 0 0 8.828 8.828z",
    fill: "#f5f5f5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M73.564 108.874v23.62c1.301.051 2.752.641 3.958 1.847s1.798 2.657 1.847 3.958h23.62v23.54H79.368c-.051 1.301-.641 2.752-1.847 3.958s-2.657 1.796-3.958 1.847v23.62h-23.54v-23.62c-1.301-.051-2.752-.641-3.958-1.847s-1.796-2.657-1.847-3.958h-23.62V138.3h23.62c.051-1.301.641-2.752 1.847-3.958s2.657-1.796 3.958-1.847v-23.62h23.541m2.941-2.944H47.08V130.177a9.488 9.488 0 0 0-3.096 2.083 9.49 9.49 0 0 0-2.084 3.096H17.655V164.782H41.901a9.48 9.48 0 0 0 2.084 3.096 9.473 9.473 0 0 0 3.095 2.083v24.245H76.506V169.96a9.475 9.475 0 0 0 3.096-2.084 9.473 9.473 0 0 0 2.083-3.095h24.245V135.355H81.686a9.475 9.475 0 0 0-2.084-3.096 9.467 9.467 0 0 0-3.096-2.083v-21.302l-.001-2.943z",
    fill: "#ff4b55"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#cdcdcd",
    d: "M102.988 138.298H73.564v-29.424H50.023v29.424H20.598v23.541h29.425v29.425h23.541v-29.425h29.424z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b4a08c"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 61.793,
    cy: 150.07,
    r: 11.77
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-134.999 48.656 163.206)",
    cx: 48.656,
    cy: 163.205,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(-45.001 74.933 163.2)",
    cx: 74.935,
    cy: 163.198,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(45.001 74.924 136.937)",
    cx: 74.922,
    cy: 136.937,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "rotate(134.999 48.65 136.931)",
    cx: 48.65,
    cy: 136.931,
    rx: 5.234,
    ry: 3.663
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.793 166.182c-8.885 0-16.113-7.226-16.113-16.113s7.228-16.113 16.113-16.113 16.113 7.228 16.113 16.113-7.228 16.113-16.113 16.113zm0-30.754c-8.072 0-14.641 6.569-14.641 14.641s6.569 14.641 14.641 14.641 14.641-6.569 14.641-14.641-6.569-14.641-14.641-14.641z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMt);
export default __webpack_public_path__ + "static/media/mt.b47d2564ba1cfc739a6719a3fcf56954.svg";
export { ForwardRef as ReactComponent };